import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { normalizeLanguageUrl } from './app/shared/utils';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

const redirectingToLanguageUrl = !environment.isLocalhost && normalizeLanguageUrl();
if (!redirectingToLanguageUrl) {
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
}
